import React, { useEffect, useRef } from "react";
import { freshpaintTrack } from "../freshpaint";

interface Props {
  id?: string;
  type?: string;
  src: string;
}

// Script that pulls user info from URL and submits to Chili Piper
const LOAD_CHILI_PIPER_VAL_SCRIPT = `
    var leadValues = {}; 
    var uri = decodeURIComponent(document.location.search.replace(/\\+/g, " ")); 
    var urlParams = new URLSearchParams(uri); 
    var entries = urlParams.entries(); 
    
    for (pair of entries) { 
      leadValues[pair[0]] = pair[1]; 
      if (pair[0].toLowerCase().includes("email") && pair[1].includes("@")) { 
        leadValues[pair[0]] = pair[1].replaceAll(" ", "+"); 
      } 
    } 

    ChiliPiper.submit("rula", "provider", { 
      map: true, 
      lead: leadValues, 
    });
`;

const ChiliPiperForm: React.FC<Props> = (props) => {
  const divRef = useRef<HTMLDivElement | null>(null);
  const { id, type, src } = props;

  useEffect(() => {
    const loadScript = (src, onLoadCallback) => {
      const node = document.createElement("script");
      node.type = type || "text/javascript";
      node.defer = true;
      node.async = true;
      node.src = src;
      node.onload = onLoadCallback;

      if (id) {
        node.id = id;
      }
      divRef.current?.appendChild(node);
    };

    // Load script provided by CMS, and then populate user info values from URL. Necessary b/c the loading 
    // of user values depends on a global variable that first chili piper script sets
    loadScript(src, () => {
      const node = document.createElement("script");
      node.text = LOAD_CHILI_PIPER_VAL_SCRIPT;
      divRef.current?.appendChild(node);
    });
  }, []);

  // Track when a booking is confirmed
  useEffect(() => {
    const trackSubmit = (event: MessageEvent) => {
      if (!event.data) return;
      
      const { data } = event;

      if (data["action"] === "booking-confirmed") {
        freshpaintTrack("provider_meeting_set");
      };
    };
      
    window.addEventListener("message", trackSubmit);
    
    return () => {
      window.removeEventListener("message", trackSubmit);
    };
  }, []);

  return <div ref={divRef}></div>;
};

export default ChiliPiperForm;
